import React from 'react';

import QnABox from './QnABox';
import styles from './styles/main-11.module.css';

export default function Main11() {
    const qnaData = [
        {
            question: 'DARVIS가 제공하는 답변은 얼마나 정확한가요?',
            answer : 'DARVIS는 자연어 → SQL, 문서 검색(RAG, TAG) 등 자체 알고리즘으로 신뢰도 높은 답변을 제공합니다. 모든 응답은 출처 기반이며, 근거가 부족한 질문에는 답하지 않도록 설계했습니다.'
        },
        {
            question: '기존의 ERP, MES 등 사내 시스템을 바꾸지 않아도 도입할 수 있나요?',
            answer: '네, DARVIS는 기존 ERP, MES, 문서 시스템 위에서 그대로 작동합니다. 시스템 교체나 물리적 통합 없이 바로 도입할 수 있습니다.'
        },
        {
            question: '우리 기업의 데이터 보안은 어떻게 보장되나요?',
            answer: 'DARVIS는 내부 서버 구축과 사용자별 접근 권한 설정을 통해 강력한 보안 체계를 제공합니다. 또한, AI가 기업의 데이터를 외부로 전송하거나 학습하지 않으므로 데이터 유출 우려가 없습니다.'
        },
        {
            question: '실시간으로 최신 데이터를 조회할 수 있나요?',
            answer: '네, DARVIS는 문서뿐만 아니라 데이터베이스에 직접 연결하여 최신 정보를 실시간으로 제공합니다. 이를 통해 신속한 의사결정이 가능합니다.'
        },
        {
            question: '도입 과정이 복잡하거나 오래 걸리지 않나요?',
            answer: 'DARVIS는 쉽고 빠른 도입 프로세스를 제공하여 기업의 부담을 최소화합니다. 복잡한 절차 없이 신속하게 시작할 수 있도록 지원해 드립니다.'
        },
        {
            question: '도입 비용이 부담되지 않을까요?',
            answer: 'DARVIS는 라이트한 옵션부터 시작할 수 있어 초기 비용 부담을 줄일 수 있으며, 투자 대비 높은 ROI를 제공합니다. 효율성과 생산성 향상을 통해 비용 절감 효과를 기대할 수 있습니다.'
        },
        {
            question: '우리 기업에 맞춤형으로 적용할 수 있나요?',
            answer: '네, DARVIS는 기업별 특성에 맞는 맞춤형 기능과 관리자 옵션을 제공합니다. 기업의 요구 사항에 따라 유연하게 커스터마이징이 가능합니다.'
        },
        {
            question: 'DARVIS가 다른 AI 솔루션과 차별화되는 점은 무엇인가요?',
            answer: '대부분의 AI는 클라우드 기반으로 운영돼 보안에 취약하고, 기존 시스템과 연동하려면 데이터 구조를 수정해야 합니다. DARVIS는 기존 데이터를 건드리지 않고, txt2SQL 기반으로 다양한 시스템의 데이터를 논리적으로 연결해 AI가 질문을 이해하고 실시간으로 답변합니다. 즉, 시스템 위에서 작동하며, 보안 + 연결성 + 업무 자동화를 동시에 실현하는 산업 특화형 Enterprise AX Layer입니다.'
        }
    ];

    return (
        <div className={styles.wrapper} id='faq-section'>
            <div className={styles.container}>
                <div className={styles.boxTitle}>
                    <p>궁금한 점을 정리했어요</p>
                    <p>FAQ</p>
                </div>
                <div className={styles.boxQnA}>
                    {qnaData.map((item, index) => (
                        <QnABox
                            key={index}
                            question={item.question}
                            answer={item.answer}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
